import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {FileRestService} from '@core/modules/rest/file/file-rest.service';
import {UnitInformationService} from '@shared/utils/unit-information.service';
import {SettingsService} from '@shared/utils/settings.service';

@Component({
    selector: 'app-basic-display-consent-text',
    templateUrl: './basic-display-consent-text.component.html',
    styleUrls: ['./basic-display-consent-text.component.scss']
})
export class BasicDisplayConsentTextComponent implements OnChanges {

    @Input() textToDisplay: string | undefined;
    @Input() textSize: string | undefined;
    @Input() indicationId: string | undefined;

    fontSize: string | undefined;

    constructor(private fileRestService: FileRestService, private unitHelper: UnitInformationService,
                private settingsService: SettingsService) {
    }

    removeTabIndexes(node: NodeList): void {
        node.forEach((item: any) => {
            item.removeAttribute('tabindex');
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.fontSize = this.settingsService.addFontClass(this.textSize);
        if (changes.textToDisplay && this.textToDisplay) {
            // TODO This should definitely be refactored at some point, I couldn't find anything useful about this in the docs (Vukasin)
            setTimeout(() => {
                const pTag: any = document.querySelector('.basic-content__text__info');
                pTag.innerHTML = this.textToDisplay;
                this.removeTabIndexes(document.querySelectorAll('.basic-content__text__info .popup-link'));
                const images = document.querySelectorAll('.content__text .inline-image');
                this.unitHelper.getInlineImage(images);
                const videos = document.querySelectorAll('.content__text .inline-video');
                this.unitHelper.getInlineVideos(videos);
            });
        }
    }
}
